import { render, staticRenderFns } from "./ContentTitle.vue?vue&type=template&id=8b2370d0&"
import script from "./ContentTitle.vue?vue&type=script&lang=js&"
export * from "./ContentTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports